import React from "react";
import { LoadioArtistPreviewTemplate } from "themes/administration/loadio/pages";
import { LoadioArtistPreviewViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new LoadioArtistPreviewViewStore(rootStore, componentProps),
    "loadioArtistPreviewViewStore"
)
class LoadioArtistPreview extends React.Component {
    render() {
        return <LoadioArtistPreviewTemplate {...this.props} />;
    }
}

export default LoadioArtistPreview;
